import { useQuery } from "@tanstack/react-query";
import { QueryBuilder } from "features/members";
import { axios } from "lib/axios";

export const getJournalEntries = ({
  churchId,
  chartOfAccountId,
  page,
  pageSize,
  queries = {}
}) => {
  const queryBuilder = new QueryBuilder();

  queryBuilder.pagination(page, pageSize);

  if (queries.search) {
    queryBuilder.search(queries.search);
  }

  if (queries.startDate && queries.endDate) {
    queryBuilder.append("start_date", queries.startDate);
    queryBuilder.append("end_date", queries.endDate);
  }

  if (queries.filter) {
    queryBuilder.filter(queries.filter);
  }

  const queryString = queryBuilder.build();

  return axios.get(
    `/churches/${churchId}/chart-of-accounts/${chartOfAccountId}/journal-entries${queryString}`
  );
};

export const useJournalEntries = ({
  churchId,
  chartOfAccountId,
  page,
  pageSize,
  queries = {},
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: [
      "journal-entries",
      churchId,
      chartOfAccountId,
      page,
      pageSize,
      JSON.stringify(queries)
    ],
    queryFn: () =>
      getJournalEntries({ churchId, chartOfAccountId, page, pageSize, queries })
  });
};
